import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface DateItem {
  title: string;
  date: string;
}

interface WishlistItem {
  title: string;
  description?: string;
  link?: string;
}

interface GuestData {
  email: string;
  name: string;
  dates: DateItem[];
  wishlistItems: WishlistItem[];
}

interface InviteState {
  inviteToken: string | null;
  creatorName: string | null;
  guestData: GuestData;
  setInviteToken: (token: string, creatorName: string) => void;
  setGuestEmail: (email: string) => void;
  setGuestName: (name: string) => void;
  setGuestDates: (dates: DateItem[]) => void;
  setGuestWishlistItems: (items: WishlistItem[]) => void;
  clearInvite: () => void;
}

const initialGuestData: GuestData = {
  email: '',
  name: '',
  dates: [],
  wishlistItems: [],
};

export const useInviteStore = create<InviteState>()(
  persist(
    (set) => ({
      inviteToken: null,
      creatorName: null,
      guestData: initialGuestData,

      setInviteToken: (token: string, creatorName: string) => {
        set({ inviteToken: token, creatorName });
      },

      setGuestEmail: (email: string) => {
        set((state) => ({
          guestData: { ...state.guestData, email },
        }));
      },

      setGuestName: (name: string) => {
        set((state) => ({
          guestData: { ...state.guestData, name },
        }));
      },

      setGuestDates: (dates: DateItem[]) => {
        set((state) => ({
          guestData: { ...state.guestData, dates },
        }));
      },

      setGuestWishlistItems: (items: WishlistItem[]) => {
        set((state) => ({
          guestData: { ...state.guestData, wishlistItems: items },
        }));
      },

      clearInvite: () => {
        set({
          inviteToken: null,
          creatorName: null,
          guestData: initialGuestData,
        });
      },
    }),
    {
      name: 'eumimo:invite',
    },
  ),
);
